module.exports = __webpack_public_path__ + "img/home_hnews8_1.1829bfed.png";